<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    sort-by="fecha"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Documentos</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                v-model="editedItem.status"
                :items="estado"
                label="Estado"
                data-vv-name="select"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <!--<v-text-field v-model="eeditedItem.Tipo" label="Tipo"></v-text-field>-->
                     <v-select
                v-model="editedItem.tipo"
                :items="tipo"
                label="Tipo"
                data-vv-name="select"></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row class="justify-content-center">
                  
                  <img 
                  :src="'https://127.0.0.1:3000/imagen/'+image.id" 
                  alt="" 
                  class="img-fluid ml-5 mr-5 pointer" 
                  v-for="image in images" :key="image.id"
                  @click="openImg(image.id)">
                </v-row>
                <v-row class="justify-content-start mt-5" v-if="editedItem.status=='Pendiente'">
                  <v-col lg="6">
                    <v-file-input
                    label="Agregar Archivo"
                    multiple
                    v-model="files"
                    >
                    </v-file-input>
                  </v-col>
                  <v-col lg="6">
                    <v-btn @click="addImages">Subir</v-btn>
                  </v-col>                  
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Actualizar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar><v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil 
      </v-icon>
      
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-clipboard-text-outline 
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>{{ item.status }}</v-chip>
    </template>
  </v-data-table>
</template>
<script>
import axios from 'axios'
import router from '../router/index.js'

  export default {
    data: () => ({
      files: [],
      images: [],
      dialog: false,
      search: '',
      headers: [
        {
          text: 'Concepto',
          align: 'left',
          sortable: true,
          value: 'concepto',
        },
        { text: 'Estado', value: 'status' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Importe', value: 'importe' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Tag',  value:  'label',  sortable: true},
        { text: 'Fecha', value: 'fecha' },
        { text: 'Acciones', value: 'action', sortable: false },
        
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        concepto: '',
        Estado: '',
        Tipo: '',
        Importe: '',
        descripcion: '',
        fecha: '',
      },
      defaultItem: {
        concepto: '',
        Estado: '',
        Tipo: '',
        Importe: '',
        descripcion: '',
        fecha: '',
      },
      tipo: ['Comprobacion','Anticipo'] ,
      estado: ['Pendiente','Actualizado','Cancelado']
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Actualizar comprobación'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },
    mounted() {
      //Config for axios
      axios.defaults.headers.common['access-token'] = this.$store.state.token;

      axios.interceptors.response.use(function (response){
          //console.log(response.data.message);
          if (response.data.message == 'Token inválida') {
              router.push({name: 'login', params: {errorToken: 'true'}});
          }else{
              return response;
          }
      });
      //End config for axios
    },
    methods: {
      async initialize () {
        let {data} = await axios.get('https://127.0.0.1:3000/comprobacion')
        this.desserts=data
        /*
        this.desserts = [
          {
            concepto: 'Alimentos',
            Estado: 'En proceso',
            Tipo: 'Comprobación',
            importe: '$ 1,259.00',
            descripcion: 'Alimentos del viaje a la sucursal de Guadalara ...',
            fecha: '10/08/2019',
          },
         {
            concepto: 'Hotel',
            Estado: 'Autorizada',
            Tipo: 'Comprobación',
            importe: '$ 2,300.00',
            descripcion: 'Hotel del viaje a la sucursal de San Luis Potosí...',
            fecha: '02/07/2019',
          },
          {
            concepto: 'Gasolina',
            Estado: 'En proceso',
            Tipo: 'Anticipo',
            importe: '$ 600.00',
            descripcion: 'Combustible para traslado a la sucursal de Guadalajara ..',
            fecha: '12/09/2019',
          },
          {
            concepto: 'Peaje',
            Estado: 'En proceso',
            Tipo: 'Anticipo',
            importe: '$ 759.00',
            descripcion: 'Costo de casetas para traslado a la sucursal de Guadalara ...',
            fecha: '25/09/2019',
          },
          {
            concepto: 'Papelería',
            Estado: 'Autorizada',
            Tipo: 'Comprobación',
            importe: '$ 400.00',
            descripcion: 'Se compran libretas, carpetas y hojas blancas para la sucursal de CDMX',
            fecha: '07/11/2019',
          },
                  {
            concepto: 'Hotel',
            Estado: 'Autorizada',
            Tipo: 'Comprobación',
            importe: '$ 2,300.00',
            descripcion: 'Hotel del viaje a la sucursal de San Luis Potosí...',
            fecha: '02/07/2019',
          },
          {
            concepto: 'Gasolina',
            Estado: 'En proceso',
            Tipo: 'Anticipo',
            importe: '$ 600.00',
            descripcion: 'Combustible para traslado a la sucursal de Guadalajara ..',
            fecha: '12/09/2019',
          },
          {
            concepto: 'Peaje',
            Estado: 'En proceso',
            Tipo: 'Anticipo',
            importe: '$ 759.00',
            descripcion: 'Costo de casetas para traslado a la sucursal de Guadalara ...',
            fecha: '25/09/2019',
          },
          {
            concepto: 'Papelería',
            Estado: 'Autorizada',
            Tipo: 'Comprobación',
            importe: '$ 400.00',
            descripcion: 'Se compran libretas, carpetas y hojas blancas para la sucursal de CDMX',
            fecha: '07/11/2019',
          },
          {
            concepto: 'Alimentos',
            Estado: 'Cancelada',
            Tipo: 'Comprobación',
            importe: '$ 1,259.00',
            descripcion: 'Alimentos del viaje a la sucursal de Guadalara ...',
            fecha: '10/08/2019',
          }
        ]*/
      },
      getColor (Estado) {
        if (Estado=='Cancelado') return 'red'
        else if (Estado=='Pendiente') return 'orange'
        else return 'green'
      },
      async editItem (item) {
        
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        await this.getimages()
        this.dialog = true
      },
      async getimages () {
          let {data} = await axios.get('https://127.0.0.1:3000/imagen/all/'+this.editedItem.id)
        this.images=data
      },
      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
        //console.log(this.editedItem)
        await axios.post(`https://127.0.0.1:3000/comprobacion/${this.editedItem.id}`,this.editedItem)

      },
      async addImages () {
        let info=new FormData()
        
        for(let x in this.files)
        {
          info.append('archivos',this.files[x])

        }
        info.append('id',this.editedItem.id)
        await axios.put('https://127.0.0.1:3000/imagen/'+this.editedItem.id,info)
        await this.getimages()
        this.files=null

      },
      openImg: function(id){
        window.open('https://127.0.0.1:3000/imagen/'+id)
      }
    },
  }
</script>
<style>
  .img-fluid{
    max-width: 300px !important;
    max-height: 350px !important;
  }


  .pointer{
    cursor: pointer;
  }
</style>